if (!customElements.get('bestsellers-section')) {
  class BestSellers extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        slider: '.bestsellers__slider',
      };

      this.setSliderWidth = this.setSliderWidth.bind(this);
      this.initSlider = this.initSlider.bind(this);
      this.handleMobileSlider = this.handleMobileSlider.bind(this);

      window.addEventListener('resize', this.setSliderWidth);
      window.addEventListener('resize', this.handleMobileSlider);
    }

    connectedCallback() {
      this.setSliderWidth();
      this.initSlider();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.setSliderWidth);
      window.removeEventListener('resize', this.handleMobileSlider);

      if (this.slider) {
        this.slider.destroy();
        this.slider = null;
      }
    }

    setSliderWidth() {
      const sliderElement = this.querySelector(this.selectors.slider);

      if (sliderElement && !sliderElement.classList.contains('grid')) {
        const containerWidth = this.getBoundingClientRect().width;

        sliderElement.style.maxWidth = containerWidth > 1600
          ? `${(containerWidth - 1600) / 2 + 1600}px`
          : '100%';
      } else {
        sliderElement.style.marginRight = 'auto';
      }
    }

    initSlider() {
      this.sliderElement = this.querySelector(this.selectors.slider);
      this.ifGrid = this.sliderElement.classList.contains('grid');

      this.isMobileView = false;
      this.slider = null;

      this.handleMobileSlider();
    }

    handleMobileSlider() {
      const breakpoint = Number(this.sliderElement.dataset.breakpoint);
      const isMobile = this.ifGrid ? window.innerWidth <= breakpoint : true;

      if (isMobile && !this.isMobileView) {
        this.isMobileView = true;

        if (!this.slider) {
          this.slider = new Swiper(this.selectors.slider, {
            slidesPerView: 'auto',
            spaceBetween: 23,
            speed: 600,
            loop: false,
            autoHeight: false,
            scrollbar: {
              el: '.swiper-scrollbar',
              draggable: true,
            },
          });
        }
      } else if (!isMobile && this.isMobileView) {
        this.isMobileView = false;

        if (this.slider) {
          this.slider.destroy();
          this.slider = null;
        }
      }
    }
  }

  customElements.define('bestsellers-section', BestSellers);
}
